import { graphql, createRefetchContainer } from 'react-relay';
import MpTemplatePlaylist from './MpTemplatePlaylist';

export default createRefetchContainer(MpTemplatePlaylist, {
  node: graphql`
    fragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist
    @argumentDefinitions(
      query: { type: "String!", defaultValue: "" }
    ) {
      id
      title
      description
      max_length
      position
      thumbnail(width: 240, height: 240) {
        url
        width
        height
      }
      playlist_recommendations {
        edges {
          node {
            id
            title
            description
            thumbnail(width: 240, height: 240) {
              url
              width
              height
            }
            num_songs
          }
        }
      }
      playlist_songs: mp_template_playlist_songs(first: 99999) @connection(
        key: "MpTemplateContainer_mp_template_playlist_songs"
      ) {
        edges {
          node {
            id
            position
            song {
              __typename
              id
              isrc
              name
              album
              artist
              song_images {
                edges {
                  node {
                    id
                    url
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
      song_search(first: 10, query: $query) {
        edges{
          node{
            id
            name
            album
            artist
            isrc
            duration_ms
            song_images {
              edges {
                node {
                  id
                  url
                  width
                  height
                }
              }
            }
            ... on SpotifySong {
              external_id
              external_source
              external_data
            }
          }
        }
      }
      mp_template {
        can_edit
        public
      }
    }
  `,
  viewer: graphql`
    fragment MpTemplatePlaylistContainer_viewer on User {
      id
      playlists(first: 99999) @connection(key: "MpTemplateContainer_playlists") {
        edges {
          node {
            id
            can_edit
            title
            description
            num_songs
            thumbnail(width: 240, height: 240) {
              url
              width
              height
            }
          }
        }
      }
      public_playlists(first: 99999) {
        edges {
          node {
            id
            can_edit
            title
            description
            num_songs
            thumbnail(width: 240, height: 240) {
              url
              width
              height
            }
          }
        }
      }
    }
  `
},
graphql`
  query MpTemplatePlaylistContainer_RefetchQuery($query: String!, $playlist_id: ID!) {
    node(id: $playlist_id) {
      ...MpTemplatePlaylistContainer_node @arguments(query: $query)
    }
  }
`);



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/MpTemplatePlaylistContainer.js